import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

const WORDS = ["Clarity", "Systems", "Scale", "Calm", "Focus", "Margin", "Ease"];

export const EditorialMarquee = () => (
  <div
    data-testid="editorial-marquee"
    className="border-y border-border bg-bone py-8 overflow-hidden"
  >
    <Marquee speed={28} gradient={false} className="marquee-motion">
      {WORDS.map((word) => (
        <span key={word} className="flex items-center">
          <span className="font-serif text-4xl sm:text-6xl font-light italic text-sage mx-10 sm:mx-16">
            {word}
          </span>
          <Asterisk className="w-6 h-6 text-clay" strokeWidth={1.5} />
        </span>
      ))}
    </Marquee>
  </div>
);
